var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 280,
    height: 70,
    viewBox: "0 0 280 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5481 8.25521H5V62.3596H34.5481V8.25521Z",
    fill: "#10C97F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9455 18.0924H44.3975V52.5224H73.9455V18.0924Z",
    fill: "#24865E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.397 51.9076H96.5667V20.5799H117.373V26.639H103.397V33.0572H115.306V39.0714H103.397V51.9076ZM137.413 51.9076H130.538V39.6548L119.798 20.5799H127.437L134.178 33.0572H134.268L140.739 20.5799H148.153L137.413 39.6099V51.9076ZM170.191 51.9076L161.608 37.0965L158.597 30.8131H158.462V37.3658V51.9076H152.036V20.5799H159.496L168.079 35.391L171.09 41.6745H171.225V35.1217V20.5799H177.651V51.9076H170.191ZM205.901 51.9076H184.555V20.5799H205.901V26.639H191.386V33.0572H203.833V39.0714H191.386V45.8486H205.901V51.9076ZM209.11 51.9076L219.176 35.7052L209.604 20.5799H217.558L223.669 31.1721H223.804L230.006 20.5799H237.375L227.714 35.8399L237.915 51.9076H230.006L223.22 40.3729H223.085L216.479 51.9076H209.11Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 54,
    fill: "white",
    transform: "translate(5 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.c5f5ea952f2adfd743ea5fbdeae08ffc.svg";
export { ForwardRef as ReactComponent };